module.exports = __webpack_public_path__ + "static/media/57.2bef355c.gif";